import { postApi } from '@utils/request';

const LogApi = {
  // 添加埋点日志
  addLog: (params) => postApi(`/data/dataCollect/collect`, params, { isLog: true })
};
export default LogApi;
